import * as r from "react";
const t = { errors: [] }, o = r.createContext(
  t
);
export {
  o as ErrorContext,
  t as defaultErrorContextProps
};
